import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { DATA_CAVEAT_START, DATA_CAVEAT_END } from './constants';

interface DataCaveatNoteProps {
  startDate: string;
  endDate: string;
}

function shouldShowCaveat(startDate: string, endDate: string): boolean {
  if (!startDate || !endDate) return false;
  // Show if date range overlaps 2025-08-01 to 2025-08-31 (inclusive)
  return startDate <= DATA_CAVEAT_END && endDate >= DATA_CAVEAT_START;
}

const DataCaveatNote: React.FC<DataCaveatNoteProps> = ({ startDate, endDate }) => {
  if (!shouldShowCaveat(startDate, endDate)) {
    return null;
  }

  return (
    <div className="flex items-start gap-3 p-4 bg-amber-50 border border-amber-300 rounded-lg">
      <FiAlertTriangle className="text-amber-600 mt-0.5 flex-shrink-0" size={18} />
      <p className="text-sm text-amber-800">
        <span className="font-semibold">Note:</span> Caliper data before September 1, 2025 is not tagged with
        a track or grade. When grouping by Track or Grade, these metrics will appear under
        &ldquo;Unknown&rdquo; track and grade.
      </p>
    </div>
  );
};

export default DataCaveatNote;
